export default __webpack_public_path__ + "static/media/hs.51a9937a.png";